const PainelOd = (props) => {


    let { ling, specs, valid, onCritChange2, sh2, onSpecChange2, onSpecBlur2, cparte2, RefA1 } = {...props};

    function validPainel (lim) {
        let x = valid (lim, specs.lims, specs.comp, specs.crit, specs.od, ling);
        let s = {...specs};
        s.lims[lim] = x;
        props.setSpecs(s);
    }

    function serv (specs, serv) {
        specs.res = null;
        if (specs.crit !== "Ranking") {
            specs.crit = "Intervalo";
            if (serv === 'pomp') {
                specs.lims = props.varGlob.refLim['pomp'][parseInt(specs.nv)];
                specs.crit = "Intervalo T";
            } else {
                specs.lims = props.varGlob.refLim[serv];
            }
        }
        props.setSpecs(specs);
        props.setComp(serv);
    }

    let promptEst = "Ver secção Referência do menu";
    if (ling === 'uk') promptEst = "See Reference section of the menu";
    let prompt = "Disponível Jan2019-Fev2021";
    if (ling === 'uk') prompt = "Jan2019-Feb2021 available";
    if (props.RefA1 === "ode") {
        prompt = "Disponível Jan2018-Fev2021";
        if (ling === 'uk') prompt = "Jan2018-Feb2021 available";
    }


    return ( 
        <div className="painelod">
            <table>
                <tbody>
                    <tr>
                        <td className="bgrd" style={{verticalAlign: 'top'}}>Usando como critério:  </td>
                        <td className="bgrd" style={{verticalAlign: 'top', paddingBottom: '10px'}}>
                            <input type="radio" id="rank" name="rankint" value="Ranking" 
                                onClick={(e) => props.setSpecs(onCritChange2(e, {...props.specs}, props.varGlob.refLim, 'ode'))} defaultChecked={props.specs.crit === 'Ranking'}></input>
                            <span style={{verticalAlign: 'top'}}>Ranking</span>
                            <input type="radio" id="interv" name="rankint" value="Intervalo"
                                onClick={(e) => props.setSpecs(onCritChange2(e, {...props.specs}, props.varGlob.refLim, 'ode'))} defaultChecked={props.specs.crit !== 'Ranking'}></input>
                            <span style={{verticalAlign: 'top'}}> Intervalo </span>
                        </td>
                    </tr>
                </tbody>
            </table> 
            <table>
                <tbody>
                    <tr>
                        <td className="bgrd" style={{paddingBottom: '10px'}}> Limites: </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="l1" value={props.specs.lims[0]} maxLength="6" size="3" onBlur={() => validPainel(0)} onChange={(e)=> props.setSpecs(sh2(0, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="l2" value={props.specs.lims[1]} maxLength="6" size="2" onBlur={() => validPainel(1)} onChange={(e)=> props.setSpecs(sh2(1, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="l3" value={props.specs.lims[2]} maxLength="6" size="2" onBlur={() => validPainel(2)} onChange={(e)=> props.setSpecs(sh2(2, e.target.value, {...props.specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="l4" value={props.specs.lims[3]} maxLength="6" size="2" onBlur={() => validPainel(3)} onChange={(e)=> props.setSpecs(sh2(3, e.target.value, {...props.specs}))}></input>
                        </td>
                    </tr>
                </tbody>
            </table>
            <table className="serv">
                <tbody>
                    <tr>
                        <td className="bgrd" style={{verticalAlign: 'top', textAlign: 'left'}}>Dias:  </td>
                        <td className="bgrd" style={{verticalAlign: 'top'}}>
                            <input type="radio" id="todos" name="dias" value="Todos"
                                onClick={(e) => props.setSpecs(onSpecChange2(e, 'dias', {...props.specs}))} defaultChecked={props.specs.dias === 'Todos'}>
                            </input>
                            <span style={{verticalAlign: 'top'}}> Todos</span>'
                            <input type="radio" id="uteis" name="dias" value="Úteis" 
                                onClick={(e) => props.setSpecs(onSpecChange2(e, 'dias', {...props.specs}))} defaultChecked={props.specs.dias === 'Úteis'}></input>
                            <span style={{verticalAlign: 'top'}}>Úteis</span></td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: 'left'}}>Anos:  </td>
                        <td className="bgrd">
                            <input type="text" id="Anos" value={props.specs.anos} placeholder={prompt} onChange={(e) => props.setSpecs(onSpecChange2(e, 'anos', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'anos', {...specs}))}></input>
                        </td>
                        <td className="bgrd" style={{width: '75px'}}>
                            <button style={{padding: '1px 10px'}}
                            type="button" title={props.TitA1}
                            onClick={() => serv (specs, RefA1) }> 
                            {props.BotA1} </button>
                        </td>
                        <td className="bgrd">
                            <button style={{padding: '1px 8px'}}
                            type="button" title="Colorir troços em função da procura e/ou oferta"
                            onClick={() => serv (specs, "pomp") }>
                            PO </button>
                        </td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: 'left'}}>Meses: </td>
                        <td className="bgrd">
                            <input type="text" id="Meses" value={props.specs.meses} onChange={(e) => props.setSpecs(onSpecChange2(e, 'meses', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'meses', {...specs}))}></input>
                        </td>
                        <td className="bgrd">
                            <button style={{padding: '1px 12px'}}
                            type="button" title="Colorir estações em função do número de validações"
                            onClick={() => serv (specs, "val") }>
                            Valid </button>
                        </td>
                        <td className="bgrd">
                            <button style={{padding: '1px 3px'}}
                            type="button" title="Colorir troços em função da oferta (DETALHES)"
                            onClick={() => serv (specs, "tms") }>
                            TMS </button>
                        </td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{textAlign: 'left', paddingBottom: '10px'}}>Horas:  </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <input type="text" id="Horas" value={props.specs.horas} onChange={(e) => props.setSpecs(onSpecChange2(e, 'horas', {...props.specs}))} onBlur={(e) => props.setSpecs(onSpecBlur2(e, 'horas', {...specs}))}></input>
                        </td>
                        <td className="bgrd" style={{paddingBottom: '10px'}}>
                            <button style={{padding: '1px 18px'}}
                            type="button" title="Colorir estações em função do número de clientes"
                            onClick={() => serv (specs, "cart") }>
                            Cart </button>
                        </td>
                    </tr>
                    <tr>
                        <td className="bgrd" style={{verticalAlign: 'top'}}>Com:  </td>
                        <td className="bgrd" style={{verticalAlign: 'top'}}>
                            <input type="radio" id="or" name="od" value="Origem" defaultChecked={props.specs.od === 'Origem'} onClick={(e) => props.setSpecs(onSpecChange2(e, 'od', {...props.specs}))} ></input>
                            <span style={{verticalAlign: 'top'}}> Origem</span>
                            <input type="radio" id="de" name="od" value="Destino" defaultChecked={props.specs.od === 'Destino'} onClick={(e) => props.setSpecs(onSpecChange2(e, 'od', {...props.specs}))} ></input>
                            <span style={{verticalAlign: 'top'}}>Destino</span>
                        </td>
                    </tr>
                    <tr>
                        {props.specs.od === 'Origem' && <td className="bgrd">Na estação n.º:   </td> }
                        {props.specs.od !== 'Origem' && <td className="bgrd">À estação n.º:   </td> }
                        <td className="bgrd"><input type="text" id="Est" value={props.specs.est} placeholder={promptEst} onChange={(e) => props.setSpecs(onSpecChange2(e, 'est', {...props.specs}))} ></input></td>
                    </tr>
                </tbody>
            </table>
            <div id="btn-group">
                <button id="lar" onClick={() => props.setSpecs(cparte2('la', {...props.specs})) } style={{ backgroundColor: props.specs.la? "orange" : "#F0F0F0" }}>La</button>
                <button id="azu" onClick={() => props.setSpecs(cparte2('az', {...props.specs})) } style={{ backgroundColor: props.specs.az? "blue" : "#F0F0F0" , color: props.specs.az? "white" : "black"}}>Az</button>
                <button id="verm" onClick={() => props.setSpecs(cparte2('verm', {...props.specs})) } style={{ backgroundColor: props.specs.verm? "red" : "#F0F0F0" , color: props.specs.verm? "white" : "black"}}>Verm</button>
                <button id="viol" onClick={() => props.setSpecs(cparte2('vi', {...props.specs})) } style={{ backgroundColor: props.specs.vi? "purple" : "#F0F0F0" , color: props.specs.vi? "white" : "black"}}>Vi</button>
                <button id="verd" onClick={() => props.setSpecs(cparte2('verd', {...props.specs})) } style={{ backgroundColor: props.specs.verd? "green" : "#F0F0F0" , color: props.specs.verd? "white" : "black"}}>Verd</button>
                <button id="tc" onClick={() => props.setSpecs(cparte2('tc', {...props.specs})) } style={{ backgroundColor: props.specs.tc? "gray" : "#F0F0F0" , color: props.specs.tc? "white" : "black"}}>TC</button>
                <button id="vevi" onClick={() => props.setSpecs(cparte2('ptc', {...props.specs})) } style={{ backgroundColor: props.specs.ptc? "red" : "#F0F0F0" , color: props.specs.ptc? "purple" : "black", fontWeight: props.specs.ptc? "bold" : "normal"}}>tc</button>
                <button id="amar" onClick={() => props.setSpecs(cparte2('am', {...props.specs})) } style={{ backgroundColor: props.specs.am? "yellow" : "#F0F0F0"}}>Am</button>
            </div>
        </div>
    );
}

export default PainelOd;